import axios from "axios";

import { FlagPayload } from "fe-shared-requests/src/components";

export const flagPickupRequest = (
  requestNumber: string,
  payload: FlagPayload
): Promise<void> =>
  axios
    .post(`pickupRequests/${requestNumber}/flag`, payload)
    .then(() => undefined);

export const unflagPickupRequest = (requestNumber: string): Promise<void> =>
  axios.post(`pickupRequests/${requestNumber}/unflag`).then(() => undefined);
